import React from 'react';
import styled from 'styled-components';
import CashSaver from './Components/CashSaver';
import { useTranslation } from 'react-i18next';
import CashSaverBrands from './Components/CashSaverBrands';
import { isMobile } from '../Common/Utils/platforms';
import Faq from './Components/Faq';
import ActivationButtons from './Components/ActivationButtons';
import { getDesktopExtensionInstallButtonLink } from './utils';
import { Footer } from './Components/Footer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const CashSaverBrandsContainer = styled.div`
  margin-top: 30px;
`;

const FaqContainer = styled.div`
  padding-block: 70px;
  padding-inline: 24px;
`;

interface ITVActivationProps {
  isEmbeddedInAndroid?: boolean;
}

const ITVActivation: React.FC<ITVActivationProps> = ({
  isEmbeddedInAndroid,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <CashSaver
        mainText={t('extension.itvActivation.cashSaver.title')}
        subText={t('extension.itvActivation.cashSaver.explanation')}
        installExtensionLink={getDesktopExtensionInstallButtonLink()}
        desktopDownloadText={t('extension.itvActivation.cashSaver.getStarted')}
        desktopDownloadButtonText={t(
          'extension.itvActivation.cashSaver.installExtension'
        )}
      />

      {isMobile() && (
        <ActivationButtons isEmbeddedInAndroid={isEmbeddedInAndroid} />
      )}

      <CashSaverBrandsContainer>
        <CashSaverBrands
          headerText={t('extension.itvActivation.cashSaverBrands.title')}
          mainText={t('extension.itvActivation.cashSaverBrands.explanation')}
        />
      </CashSaverBrandsContainer>

      <FaqContainer>
        <Faq
          headerText={t('extension.itvActivation.faq.headerText')}
          mainText={t('extension.itvActivation.faq.mainText')}
          linkText={t('extension.itvActivation.faq.linkText')}
          faqs={[
            {
              question: t('extension.itvActivation.faq.howItWorks.question'),
              answer: t('extension.itvActivation.faq.howItWorks.answer'),
            },
            {
              question: t('extension.itvActivation.faq.howToInstall.question'),
              answer: t('extension.itvActivation.faq.howToInstall.answer'),
            },
            {
              question: t('extension.itvActivation.faq.whyTheApp.question'),
              answer: t('extension.itvActivation.faq.whyTheApp.answer'),
            },
            {
              question: t('extension.itvActivation.faq.whereCanIUse.question'),
              answer: t('extension.itvActivation.faq.whereCanIUse.answer'),
            },
          ]}
        />
      </FaqContainer>
      {!isEmbeddedInAndroid && (
        <Footer text={t('extension.itvActivation.footer.policyText')} />
      )}
    </Container>
  );
};

export default ITVActivation;
